"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var composition_1 = require("./composition");

var utils_1 = require("./utils");

var assign = Object.assign;

exports.createFactory = function (_a) {
  var namespace = _a.namespace,
      actionName = _a.actionName,
      reducer = _a.reducer;
  var actionType = namespace + "/" + actionName;

  var creator = function creator(payload) {
    return {
      payload: payload,
      type: namespace + "/" + actionName
    };
  };

  Object.defineProperty(creator, "name", {
    value: actionType,
    writable: false
  });

  var _reducer = function _reducer(state, action) {
    if (action.type === actionType) {
      return reducer(state, action);
    } else {
      return state;
    }
  };

  var extra = {
    actionName: actionName,
    merge: function merge(param) {
      return exports.createFactory(__assign({
        namespace: namespace
      }, param, {
        reducer: composition_1.composeReducer(reducer, param.reducer ? param.reducer : utils_1.identity)
      }));
    },
    assign: function assign(param) {
      return exports.createFactory(__assign({
        namespace: namespace,
        reducer: reducer
      }, param));
    },
    namespace: namespace,
    reducer: _reducer,
    type: actionType
  };
  var output = assign(creator, extra);
  return output;
};

exports.createAsyncFactory = function (_a) {
  var namespace = _a.namespace,
      actionName = _a.actionName,
      requestReducer = _a.requestReducer,
      fulfillReducer = _a.fulfillReducer,
      errorReducer = _a.errorReducer;
  var actionType = namespace + "/" + actionName;
  var actionTypes = {
    error: actionType + "_ERROR",
    fulfill: actionType + "_FULFILL",
    request: actionType
  };

  var requestCreator = function requestCreator(payload) {
    return {
      payload: payload,
      type: actionTypes.request
    };
  };

  Object.defineProperty(requestCreator, "name", {
    value: actionTypes.request,
    writable: false
  });

  var fulfillCreator = function fulfillCreator(payload) {
    return {
      payload: payload,
      type: actionTypes.fulfill
    };
  };

  Object.defineProperty(fulfillCreator, "name", {
    value: actionTypes.fulfill,
    writable: false
  });

  var errorCreator = function errorCreator(payload) {
    return {
      payload: payload,
      type: actionTypes.error
    };
  };

  Object.defineProperty(errorCreator, "name", {
    value: actionTypes.error,
    writable: false
  });

  var _errorReducer = function _errorReducer(state, action) {
    if (action.type === actionTypes.error) {
      return errorReducer(state, action);
    } else {
      return state;
    }
  };

  var _fulfillReducer = function _fulfillReducer(state, action) {
    if (action.type === actionTypes.fulfill) {
      return fulfillReducer(state, action);
    } else {
      return state;
    }
  };

  var _requestReducer = function _requestReducer(state, action) {
    if (action.type === actionTypes.request) {
      return requestReducer(state, action);
    } else {
      return state;
    }
  };

  var extra = {
    actionName: actionName,
    error: errorCreator,
    errorReducer: _errorReducer,
    errorType: actionTypes.error,
    merge: function merge(param) {
      return exports.createAsyncFactory(__assign({
        namespace: namespace
      }, param, {
        requestReducer: composition_1.composeReducer(param.requestReducer ? param.requestReducer : utils_1.identity, requestReducer),
        errorReducer: composition_1.composeReducer(param.errorReducer ? param.errorReducer : utils_1.identity, errorReducer),
        fulfillReducer: composition_1.composeReducer(param.fulfillReducer ? param.fulfillReducer : utils_1.identity, fulfillReducer)
      }));
    },
    assign: function assign(param) {
      return exports.createAsyncFactory(__assign({
        namespace: namespace,
        requestReducer: requestReducer,
        errorReducer: errorReducer,
        fulfillReducer: fulfillReducer
      }, param));
    },
    fulfill: fulfillCreator,
    fulfillReducer: _fulfillReducer,
    fulfillType: actionTypes.fulfill,
    namespace: namespace,
    reducer: composition_1.composeReducer(_requestReducer, _errorReducer, _fulfillReducer),
    request: requestCreator,
    requestReducer: _requestReducer,
    requestType: actionTypes.request,
    type: actionType
  };
  var output = assign(requestCreator, extra);
  return output;
};